export enum StoreMemberEnums {
  members = 'StoreMember/Members', // 取得店家成員清單
  membersV2 = 'v2/StoreMember/Members', // 新系統：取得店家成員清單
  hideIdentity = 'StoreMember/HideIdentity', // 對底下所有成員隱身
  memberInfo = 'StoreMember/Member', // 取得成員資訊
  updateMember = 'StoreMember/Update', // 變更成員
  deleteMember = 'StoreMember/Delete', // 刪除成員
  addInvite = 'StoreMember/AddInvite', // 邀請新成員
  memberJoin = 'StoreMember/MemberJoin' // 成員加入
}
